export const QUIZ_SESSION_OVERLAY_ELEMENT_KIND = "quiz.session" as const;
